// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__S6hWJ","tabsBox":"styles_tabsBox__2qXQB","createButton":"styles_createButton__3Lo9G"};